import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { Box, Typography } from "@mui/material";
import { VechileIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectStatCards } from "../../redux/selector";
import { StatCardIcon } from "../../types";
import { useStyles } from "./styles";

const getIcon = (icon: StatCardIcon, styles: ReturnType<typeof useStyles>) => {
  if (icon === "vehicle") {
    return <VechileIcon />;
  }

  return (
    <Box className={styles.phoneIcon}>
      <PhoneOutlinedIcon />
    </Box>
  );
};

const StatCards = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const statCards = useSelector(selectStatCards);

  return (
    <div className={styles.cardsGrid} dir={i18n.dir()}>
      {statCards.map((item) => (
        <Box key={item.id} className={styles.card} dir={i18n.dir()}>
          <Box className={styles.topRow}>
            {getIcon(item.icon, styles)}
            <Typography component="p" className={styles.value}>
              {item.value}
            </Typography>
          </Box>
          <Typography component="p" className={styles.label}>
            {t(item.labelKey)}
          </Typography>
        </Box>
      ))}
    </div>
  );
};

export default StatCards;
